import { combineReducers } from 'redux';
import app from 'modules/App/store/reducer';
import user from 'modules/Users/store/reducer';
import project from 'modules/Projects/store/reducer';
import web from 'modules/Web/store/reducer';
import illustration from 'modules/Illustration/store/reducer';
import team from 'modules/Team/store/reducer';

export default () =>
  combineReducers({
    app,
    user,
    project,
    web,
    illustration,
    team,
  });
